import { render, staticRenderFns } from "./LoteCardVertical.vue?vue&type=template&id=676d8b62&scoped=true"
import script from "./LoteCardVertical.vue?vue&type=script&lang=js"
export * from "./LoteCardVertical.vue?vue&type=script&lang=js"
import style0 from "./LoteCardVertical.vue?vue&type=style&index=0&id=676d8b62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d8b62",
  null
  
)

export default component.exports